import { KYMW2700Model } from '../kymw2700.model';
import { KYMW2700PhaseFixationModel } from '../vo/kymw2700-phase-fixation.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 基版コピー・フェーズ管理画面　フェーズを確定するサービス
 *
 * @export PhaseFixationService
 * @class PhaseFixationService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class PhaseFixationService extends PlessJsonResponderSub<any> {

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW2700Model}
   * @memberof PhaseFixationService
   */
  private model: KYMW2700Model;

  /**
   * 処理に使用するVO
   *
   * @private
   * @type {KYMW2700PhaseFixationModel}
   * @memberof PhaseFixationService
   */
  private vo: KYMW2700PhaseFixationModel;

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof PhaseFixationService
   */
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof PhaseFixationService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OrderCode: this.vo.orderCode,
        MediumType: this.vo.mediumType,
        PhaseCode: this.vo.phaseCode,
        ForcedPhaseFixationFlag: this.vo.forcedPhaseFixationFlag,
        CommitDataBaseFlag: this.vo.commitDataBaseFlag,
        PhaseSkipFlag: this.vo.phaseSkipFlag,
        IsFirstFlg: this.vo.isFirstFlg,
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param vo
   * @param {Function} successFunc 成功時後続処理
   * @memberof PhaseFixationService
   */
  execute(model: any, vo: any, successFunc: Function): void {
    this.model = <KYMW2700Model>model;
    this.vo = <KYMW2700PhaseFixationModel>vo;
    this.successFunc = successFunc;
    this.send('phaseFixation', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof PhaseFixationService
   */
  success(data: any): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }

}
